import { FormRows, FormRowsProps } from 'ui-builder';

export type { FormRowsProps };

export default FormRows;
